

<template>
    <div class="vue timparty-band-contest band-contest">

        <div class="band-contest-content" v-if="current_contest">
          <div class="container">
            <div class="row row-eq-height">


              
              
              <div class="col-lg-6 h-100 order-2 order-sm-1 py-5 p-md-0 d-flex align-content-center">
                <!-- <div class="half-container p-3 p-md-5"> -->

                  <div class="p-3 p-md-5">
                  
                    <div class="badge badge-accent">{{ current_contest.name }}</div>
                    <badge-counter v-if="current_contest.badgeAvailable" :badge-count="current_contest.badgeAvailable"></badge-counter>
                
                    
                    <h2 class="section-title my-3" v-html="current_contest.title"></h2>
                    <div class="section-content" v-html="current_contest.description">
                    
                    </div>
                    <a v-if="current_contest.extra && current_contest.extra.url" :href="current_contest.extra.url" class="btn btn-primary btn-lg btn-block mt-4">{{ __('SCOPRI DI PIÙ') }}</a>
                  </div>
              
                <!-- </div> -->
              </div>

              <div class="col-lg-6  order-1 order-sm-2  p-0 d-flex align-content-center" >
                  <!-- <div class="half-container h-100 d-flex align-items-end justify-content-center"> -->
                    <div>
                      <img :src="contest_image" class="img-fluid">
                      <countdown v-if="countdown.time" class="instant-win-countdown" :ts-end="countdown.time" :heading="countdown.label"></countdown>
                    </div>
                  <!-- </div> -->
              </div>
            </div>
          </div>
        </div>

    </div>
</template>

<script>

    /* eslint-disable */ 

    import TimPartyMixin from '../mixins/TimPartyMixin';
    import Countdown from './Countdown.vue'
    import BadgeCounter from './BadgeCounter.vue'

    export default {
      name: 'BandContest',
      mixins: [ TimPartyMixin ],
      components: { Countdown, BadgeCounter },
      props: {
        apiUrl: {
          type: String,
          required: true,
        },
        code: {
          type: String,
          required: false,
        },
        contest: {
          type: Object,
          required: false,
          default: null,
        }
        
      },
      data: function(){

        return {
          current_contest: {},
        };
      },
      mounted: function(){
        this.setApiUrl(this.apiUrl);
        if( !this.contest && this.code )
          this.getContest();
        else
          this.current_contest = this.contest;
      },
      methods: {
        getContest: function( callback ){


          if(!this.code)
            return false;


          var self = this;

          var payload = {
            action: 'get',
            access_token: this.access_token,
            contest_code: this.code,

          };

          this.loading = true;

          this.callApiGet( payload, function( response){

            self.loading = false;
            self.current_contest = response.data;

            if(callback)
              callback();

          } );
        
        }
      },
      computed:{
        contest_image: function(){

          if( _.has( this.current_contest, 'extra.images.featured' ))
            return this.current_contest.extra.images.featured[0];
          else if( _.has( this.current_contest, 'extra.images.slider' ))
            return this.current_contest.extra.images.slider[0];
          else return null;

        },
        

        countdown: function(){

          var now = Math.floor(new Date().getTime() / 1000);

          var result = {
            label: '',
            time: null,
          };

          if(this.current_contest){

            if(this.current_contest.startDate != undefined && now < this.current_contest.startDate){
              result.label = this.__('MANCANO SOLO');
              result.time = this.current_contest.startDate;
            }
            else if(this.current_contest.endDate != undefined && now < this.current_contest.endDate){
              result.label = this.__('SCADE TRA');
              result.time = this.current_contest.endDate;
            }
          }

          return result;

        },

      }
    }
  </script>


